document.addEventListener('DOMContentLoaded', () => {
    const backToTopBtn = document.querySelector('#backToTop');

    if (!backToTopBtn) return;

    const updateVisibility = () => {
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        const halfwayPoint = scrollableHeight * 0.5;

        if (window.scrollY > halfwayPoint) {
            backToTopBtn.classList.add('show');
        } else {
            backToTopBtn.classList.remove('show');
        }
    };

    window.addEventListener('scroll', updateVisibility, { passive: true });

    backToTopBtn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});
